import React from 'react';
import './Modal.css';

const Modal = ({ isOpen, onClose, title, children, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h3 className="modal-title">{title}</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-content">
          {children}
        </div>
        <div className="modal-footer">
          <button className="modal-button cancel-button" onClick={onClose}>取消</button>
          <button className="modal-button confirm-button" onClick={onConfirm}>确认</button>
        </div>
      </div>
    </div>
  );
};

export default Modal; 